const authors = () => {
  return '/authors'
}

export default authors